// interceptor to catch errors
import router from '@/plugins/router';

const errorInterceptor = (error) => {
  // check if it's a server error
  if (!error.response) {
    console.warn('Network/Server error');
    return Promise.reject(error);
  }

  // all the other error responses
  switch (error.response.status) {
  case 400:
    console.error('Data Not Found', error.response.status, error.message);
    break;

  case 401: // authentication error, logout the user
    console.warn('Please login again', 'Session Expired');
    localStorage.removeItem('token');
    router.push('/login');
    break;

  default:
    console.error('Server Error', error.response.status, error.message);
    console.error();
  }
  return Promise.reject(error);
};

export default errorInterceptor;
